import { lazy } from "react";
import { Outlet } from "react-router";
import { RoleGuard } from "../contexts/RoleGuard";
import { AuthGuard } from "../utils/AuthGuard";
import { ScreenLoader } from "../utils/ScreenLoader";

const AddCredit = ScreenLoader(lazy(() => import("../screens/super-admin-screen/AddCredit")));

const ResetOtp = ScreenLoader(lazy(() => import("../screens/super-admin-screen/ResetOtp")));

const ResetPassword = ScreenLoader(
  lazy(() => import("../screens/super-admin-screen/ResetPassword")),
);

// Mapping the super admin route
export const SuperAdminRoute = () => ({
  path: "super-admin",
  element: (
    <AuthGuard>
      <Outlet />
    </AuthGuard>
  ),
  children: [
    {
      path: "add-credit",
      element: (
        <RoleGuard isSuperAdmin={true}>
          <AddCredit />
        </RoleGuard>
      ),
    },
    {
      path: "reset-otp",
      element: (
        <RoleGuard isSuperAdmin={true}>
          <ResetOtp />
        </RoleGuard>
      ),
    },
    {
      path: "reset-password",
      element: (
        <RoleGuard isSuperAdmin={true}>
          <ResetPassword />
        </RoleGuard>
      ),
    },
  ],
});
